import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchFilter } from '../model/search-filters/search-filter';

@Injectable({
  providedIn: 'root',
})
export class SearchFilterService {
  constructor(private httpClient: HttpClient) {}

  public getAll(): Observable<SearchFilter[]> {
    const url = `/upstream/gymfinder/internal/admin/v1/search-filter`;
    return this.httpClient.get<SearchFilter[]>(url, { withCredentials: true });
  }

  public create(searchFilter: SearchFilter): Observable<SearchFilter> {
    const url = '/upstream/gymfinder/internal/admin/v1/search-filter';
    return this.httpClient.post<SearchFilter>(url, searchFilter, {
      withCredentials: true,
    });
  }
  public update(
    searchFilterId: string,
    searchFilter: SearchFilter
  ): Observable<SearchFilter> {
    const url = `/upstream/gymfinder/internal/admin/v1/search-filter/${searchFilterId}`;
    return this.httpClient.put<SearchFilter>(url, searchFilter, {
      withCredentials: true,
    });
  }
}
